import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { BikeleasingBIcon } from 'probonio-shared-ui/component/icon';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';

export class BikeleasingBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Bikeleasing;

  get Icon(): React.ComponentType<SvgIconProps> {
    return BikeleasingBIcon;
  }
}
